module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderMobile/DotcomHeaderMobileLoginPrompt/DotcomHeaderMobileLoginPrompt.module.scss");